"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonTd = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var lodash_1 = require("lodash");
var index_modules_css_1 = __importDefault(require("portal/index.modules.css"));
var react_1 = __importDefault(require("react"));
var ButtonTd = function (props) {
    var _a, _b;
    var _c = props.cell, colSpan = _c.colSpan, action = _c.action, payload = _c.payload, rowSpan = _c.rowSpan;
    var style = props.style;
    var onButtonClickedV = props.onButtonClicked;
    var button = ((0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ className: index_modules_css_1.default.gridButton, style: { color: props.cell.color, backgroundColor: props.cell.buttonColor }, type: (_b = (_a = props.cell.extraProps) === null || _a === void 0 ? void 0 : _a.mode) !== null && _b !== void 0 ? _b : 'primary', size: "small", onClick: props.cell.confirmAction ? lodash_1.noop : function () { return (onButtonClickedV || lodash_1.noop)(action, payload); } }, { children: action })));
    return ((0, jsx_runtime_1.jsx)("td", __assign({ className: index_modules_css_1.default.gridTdButton, style: style, colSpan: colSpan, rowSpan: rowSpan }, { children: props.cell.confirmAction ? ((0, jsx_runtime_1.jsx)(antd_1.Popconfirm, __assign({ title: props.cell.confirmMessage || 'Are you sure?', onConfirm: function () { return (onButtonClickedV || lodash_1.noop)(action, payload); }, onCancel: function () { return (0, lodash_1.noop)(action, payload); }, okText: "Yes", cancelText: "No" }, { children: button }))) : (button) })));
};
exports.ButtonTd = ButtonTd;
